export const CUSTOM_VIEW_CUSTOM_ENTITY_GLIST_CONFIG = {
    name            : 'External data list',
    icon            : 'i5-tasks',
    image           : 'list',
    iconSvg         : 'isvg-view-list',
    url             : 'external-list',
    description     : 'The External Data List View allows users to access and interact with real-time data from external sources in a clear, organized format.'
}
